import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { environment } from '../../../environments/environment';
import { ClinicalBackground } from '../models/clinical-background';

@Injectable({
  providedIn: 'root',
})
export class ClinicalBackgroundEntityService extends BaseEntityService<ClinicalBackground> {
  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl,
      {
        singular: 'clinicalBackground',
        plural: 'clinicalBackgrounds',
        url: 'clinical-backgrounds',
      },
      routerParamsService,
    );
    this.nameId = 'clinicalBackgroundId';
  }
}
